import Result from "@/core/common/Result";
import {
  IListarVoucherGateway,
  IListarVoucherGatewayResponse
} from "../ports/ListarVoucherGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import type { HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import "reflect-metadata";

@injectable()
export class ListarVoucherGatewayAdapter implements IListarVoucherGateway {
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly client!: HttpClient;

  async getVoucher(): Promise<Result<IListarVoucherGatewayResponse>> {
    try {
      const response = await this.client.get<
        IDefaultContabilResponse<IListarVoucherGatewayResponse>
      >({
        url: "/v1/contabil/voucher/"
      });

      if (response.body?.code !== 200 || response.statusCode !== 200)
        return Result.fail("Não foi possível buscar o voucher");

      return Result.ok(response.body.result);
    } catch (_e) {
      return Result.fail("Erro ao buscar o voucher");
    }
  }
}
